import useDropdownData from "../hooks/useDropdownData";
import { urlApi } from "../helpers/functionHelpers";

const FormularioTransportista = ({
  dataTransportista,
  setDataTransportista,
  handleChange,
  handleSubmit,
  loadingReservacion,
  errorReservacion,
  setCompania,
}) => {
  const {
    data: vehiculos,
    loading: loadingVehiculos,
    error: errorVehiculos,
  } = useDropdownData(
    `${urlApi}/api/vehiculos`,
    setDataTransportista,
    dataTransportista.vehiculo_id,
    true
  );
  return (
    <form className="additional-info-form">
      <h2>Datos del Transportista</h2>
      <div className="form-group">
        <label htmlFor="nameOpr">Nombre Operador:</label>
        <input
          type="text"
          id="nameOpr"
          name="nameOpr"
          value={dataTransportista.nameOpr}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="telefonoOpr">Teléfono Operador:</label>
        <input
          type="text"
          id="telefonoOpr"
          name="telefonoOpr"
          value={dataTransportista.telefonoOpr}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="correoTrp">Correo del transportista:</label>
        <input
          type="text"
          id="correoTrp"
          name="correoTrp"
          value={dataTransportista.correoTrp}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="vehiculo_id">Tipo de vehiculo:</label>
        {loadingVehiculos ? (
          <p>Cargando vehiculos...</p>
        ) : errorVehiculos ? (
          <p>Error: {errorVehiculos}</p>
        ) : (
          <select
            name="vehiculo_id"
            value={dataTransportista.vehiculo_id || ''}
            onChange={handleChange}
          >
            <option value="">-- Seleccione Vehículo --</option>
            {vehiculos.map((vehiculo) => (
              <option key={vehiculo.id} value={vehiculo.id}>
                {vehiculo.vehiculo}
              </option>
            ))}
          </select>
        )}
      </div>
      <div className="form-group">
        <label htmlFor="placa">Placa</label>
        <input
          type="text"
          id="placa"
          name="placa"
          value={dataTransportista.placa}
          onChange={(e) =>
            setDataTransportista({
              ...dataTransportista,
              placa: e.target.value.toUpperCase(), // Convierte a mayúsculas
            })
          }
        />
      </div>
      <div className="form-group">
        <label htmlFor="companiaProveedor">Compañía</label>
        <input
          type="companiaProveedor"
          id="companiaProveedor"
          name="companiaProveedor"
          value={dataTransportista.companiaProveedor}
          onChange={handleChange}
        />
        <button type="submit" className="compania" onClick={setCompania}>
          Misma del proveedor
        </button>
      </div>
      <div className="form-group">
        <label htmlFor="numOprUdad">Número de operadores por unidad</label>
        <input
          type="numOprUdad"
          id="numOprUdad"
          name="numOprUdad"
          value={dataTransportista.numOprUdad}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="personalAdcnl">
          Número de personal adicional para maniobras
        </label>
        <input
          type="personalAdcnl"
          id="personalAdcnl"
          name="personalAdcnl"
          value={dataTransportista.personalAdcnl}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="cometariosTrp">Comentarios:</label>
        <textarea
          id="cometariosTrp"
          name="cometariosTrp"
          value={dataTransportista.cometariosTrp}
          onChange={handleChange}
        ></textarea>
      </div>
      <section className="form-section">
        <button
          type="button"
          disabled={loadingReservacion}
          className="submit-button"
          onClick={handleSubmit}
        >
          Crear reservación
        </button>
        {errorReservacion && (
          <p style={{ color: "red" }}>Error: {errorReservacion}</p>
        )}
      </section>
    </form>
  );
};

export default FormularioTransportista;